<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12>
              <p class="headline text-xs-left" v-if="this.formaction == 'create'">Add Sponsor</p>
              <p class="headline text-xs-left" v-if="this.formaction == 'edit'">Edit Sponsor</p>
            </v-flex>
            <v-flex md12>
              <v-text-field
                v-model="Form.name"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="sponsorForm"
                :error-messages="errors.collect('sponsorForm.name')"
                hide-details
                :counter="50"
                label="Sponsor Name*"
                name="name"
              />
            </v-flex>

            <v-flex xs6>
              <v-select
                v-model="Form.number"
                :items="numberItems"
                chips
                label="Number*"
                name="number"
              />
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                label="Applies to the following Portals"
                multiple
              ></v-select>
            </v-flex>
            <v-flex xs12 sm2 class="input-container">
               <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;" color="primary"></v-switch>
             
            </v-flex>
            <v-flex xs12 sm2 class="input-container">
              <span v-if="Form.active" style="padding-top: 25px;">Active</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.active" style="padding-left: 15px;" color="primary"></v-switch>
              
            </v-flex>

            <!-- Filestack upload button -->
            <v-flex xs12 sm6 class="text-xs-left"></v-flex>
            <v-flex xs12 sm12 class="text-xs-center">
              <!-- Filestack display icon -->
              <vdownload
                v-if="Form.icon"
                url="https://cdn.filestackcontent.com/"
                :apikey="integration.fsAPIKey"
                :policy="integration.fsReadPolicy"
                :signature="integration.fsReadSignature"
                :handle="Form.icon.handle"
                width="100"
                height="100"
                tag="img"
                :v-bind:embed="true"
                classes
              ></vdownload>
              <vupload
                :apikey="integration.fsAPIKey"
                :path="portal.active.id + '/sponsors/'"
                v-bind:accept="['image/*']"
                :policy="integration.fsUploadPolicy"
                :signature="integration.fsUploadSignature"
                :label="changeIconLabel(Form.icon)"
                classes="secondary v-btn white--text"
                v-on:result="uploadResult = $event"
              ></vupload>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="prymary darken-1" flat @click.native="SaveDocument('sponsorForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vupload from "@/components/filestack/vupload.vue";
import vdownload from "@/components/filestack/vdownload.vue";

export default {
  //filestack
  components: {
    vupload,
    vdownload
  },
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      id: null,
      icon: null,
      name: null,
      panelID: "1",
      number: null,
      method: "addClipData",
      portalID: [],
      enabled: true,
      active: true
    },
    numberItems: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
    modal: false,
    //filestack
    dialog: false,
    displayIcon: false,
    folderPath: "/sponsors/",
    uploadResult: "Nothing",
    files: [],
    apikey: "A9Qx1trOUQuO4jYrB95b2z",
    downloadurl: "https://cdn.filestackcontent.com/",
    output: "",
    readpolicy:
      "eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9",
    readsignature:
      "e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
  }),
  computed: {
    ...mapState({
      integration: state => state.integration
    })
  },
  watch: {
    form: {
      handler: function() {
        if (this.form.id) {
          this.Form.id = this.form.id;
        }
        if (this.form.portalID) {
          this.Form.portalID = this.form.portalID;
        }
        if (this.form.icon) {
          this.Form.icon = this.form.icon;
        }
        if (this.form.name) {
          this.Form.name = this.form.name;
        }
        if (this.form.panelID) {
          this.Form.panelID = this.form.panelID;
        }
        if (this.form.number) {
          this.Form.number = this.form.number;
        }
        if (this.form.method) {
          this.Form.method = this.form.method;
        }
        if (this.form.enabled) {
          this.Form.enabled = this.form.enabled;
        }
        if (this.form.active) {
          this.Form.active = this.form.active;
        }
      },
      deep: true
    },
    uploadResult() {
      this.Form.icon = this.uploadResult[0];
    }
  },
  methods: {
    changeIconLabel: function(icon) {
      if (icon) {
        return "Change icon";
      } else {
        return "Upload icon";
      }
    },
    CloseDialog() {
      this.$emit("Dialog", false);
      this.uploadResult = [];
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          switch (this.formaction) {
            case "create":
              // this.Form.icon = this.CreateURL(file.handle);
              this.$store.dispatch("Admin/createDocument", [
                this.admin.Collection,
                this.Form,
                "Admin/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              // console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              // console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    },
    CreateURL(handle) {
      return (
        this.downloadurl +
        //this.uploadResult[0].key
        this.integration.fsAPIKey +
        this.output +
        "/security=policy:" +
        this.integration.fsReadPolicy +
        ",signature:" +
        this.integration.fsReadSignature +
        "/" +
        handle
      );
    },
    mounted() {
      this.$store.dispatch("portal/readLookups", [
        "lookups",
        this.portal.active.id,
        "portal/setLookups",
        "portal/setLookupsResult"
      ]);
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>
